export const getTaskEstimate = (taskEstimateId) =>
  fetch(`/task_estimates/${taskEstimateId}.json`)
    .then(response => response.json());
